<section [hidden]="hiddendata()" class="uk-section uk-padding-small uk-padding-remove-bottom +background-blog">
    <div class="uk-container uk-flex uk-flex-wrap uk-flex-middle">
        <div class="uk-width-1-2@m uk-text-center uk-text-left@m">
            <h1 class="uk-heading-medium">กรอกข้อมูล</h1>
            <h2 class="uk-h3 uk-margin-remove-top">เพื่อให้เจ้าหน้าที่ติดต่อกลับ</h2>
        </div>
        <div class="uk-width-1-2@m uk-text-center uk-text-right@m">
            <img src="/assets/images/bg-leads.svg" alt="กรอกข้อมูล เพื่อให้เจ้าหน้าที่ติดต่อกลับ" />
        </div>
    </div>
</section>

<form autocomplete="off" #f="ngForm" (ngSubmit)="f.valid && executeImportantAction()"
    class="uk-section uk-container uk-container-small uk-form-stacked" novalidate appResponsiveCheck
    #reseize="appResponsiveCheck" autocomplete="off">
    @if (hiddendata()) {
    <header class="uk-text-center uk-margin-medium-bottom">
        <h4 class="uk-margin-small-bottom">ผลิตภัณฑ์ที่ท่านสนใจคือ</h4>
        <h5 class="uk-margin-remove">{{productName()||'-'}}</h5>
    </header>
    }
    @if (hiddendata() == false) {
    <header class="uk-text-center uk-margin-medium-bottom">
        <h2 class="uk-margin-small-bottom">ผลิตภัณฑ์ที่ท่านสนใจคือ</h2>
        <h3 class="uk-margin-remove">{{productName()||'-'}}</h3>
    </header>
    }
    <div class="uk-flex uk-flex-center">
        <div class="uk-width-5-6@s uk-width-3-4@m">
            <!-- First name -->
            <div class="uk-margin-small-bottom">
                <div class="uk-child-width-1-2@s uk-grid">
                    <div>
                        <label class="uk-form-label" for="first-name">ชื่อ</label>
                        <div class="uk-form-controls uk-position-relative">
                            <input class="uk-input uk-border-rounded" type="text" placeholder="ชื่อของคุณ"
                                autocomplete="off" name="first_name" [(ngModel)]="model.first_name"
                                #first_name="ngModel" [ngClass]="addClass(f,'first_name')" required
                                [pattern]="regName" />
                            <small class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error"
                                tabindex="-1" [ngClass]="addClass(f,'first_name','msg')">
                                <span>
                                    @if (first_name.errors && first_name.errors.required) {
                                        <span>กรุณาใส่ชื่อ</span>
                                    }
                                    @if (first_name.errors && first_name.errors.pattern) {
                                        <span>ชื่อของคุณไม่ถูกหลัก</span>
                                    }
                                </span>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Last name -->
            <div class="uk-margin-small-bottom">
                <div class="uk-child-width-1-2@s uk-grid">
                    <div>
                        <label class="uk-form-label" for="last-name">นามสกุล</label>
                        <div class="uk-form-controls uk-position-relative">
                            <input class="uk-input uk-border-rounded" type="text" placeholder="นามสกุลของคุณ"
                                autocomplete="off" name="last_name" [(ngModel)]="model.last_name" #last_name="ngModel"
                                [ngClass]="addClass(f,'last_name')" required [pattern]="regName" />
                            <small class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error"
                                tabindex="-1" [ngClass]="addClass(f,'last_name','msg')">
                                <span>
                                    @if (last_name.errors && last_name.errors.required) {
                                        <span>กรุณาใส่นามสกุล</span>
                                    }
                                    @if (last_name.errors && last_name.errors.pattern) {
                                        <span>นามสกุลของคุณไม่ถูกหลัก</span>
                                    }
                                </span>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Mobile/Phone -->
            <div class="uk-margin-small-bottom">
                <div class="uk-child-width-1-2@s uk-grid">
                    <div>
                        <label class="uk-form-label" for="form_tel">เบอร์โทรศัพท์</label>
                        <div class="uk-form-controls uk-position-relative">
                            <input id="form_tel" class="uk-input uk-border-rounded" placeholder="เบอร์โทรศัพท์ของคุณ"
                                autocomplete="off" name="telephone_no" [(ngModel)]="model.telephone_no"
                                #telephone_no="ngModel" [ngClass]="addClass(f,'telephone_no')" required
                                [pattern]="regTel" minlength="10" maxlength="10" />

                            <small class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error"
                                tabindex="-1" [ngClass]="addClass(f,'telephone_no','msg')">
                                <span>
                                    @if (telephone_no.errors && telephone_no.errors.required) {
                                        <span>กรุณาใส่เบอร์โทรศัพท์</span>
                                    }
                                    @if (telephone_no.errors && telephone_no.errors.pattern || telephone_no.errors&&telephone_no.errors.minlength) {
                                        <span>กรุณาใส่เบอร์โทรศัพท์ให้ถูกต้อง</span>
                                    }
                                </span>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Province -->
            @if (product_name() == 'life-insurance' || product_name() == 'ci-extra-care' || product_name() == 'smart-ci' || product_name() == 'my-care-easy-health') {
            <div
                class="uk-margin-small-bottom">
                <div class="uk-child-width-1-2@s uk-grid">
                    <div>
                        <label class="uk-form-label" for="form_province">จังหวัด</label>
                        <div class="uk-form-controls uk-position-relative">
                            <input class="uk-input uk-border-rounded" type="hidden" id="province" placeholder="จังหวัดที่คุณอยู่"
                                value="" name="province" [(ngModel)]="model.province" />
                            <ng-autocomplete [data]="results.province" [searchKeyword]="keyword"
                                (selected)="onSelect2($event,'province','current')"
                                (inputChanged)="onChangeSearch2($event,'province','current')"
                                (inputCleared)="onClearSelect('province')" [itemTemplate]="itemProvince" name="provinceText"
                                [(ngModel)]="province" [isLoading]="isLoading" placeholder="จังหวัด"
                                [notFoundTemplate]="notFoundTemplate"></ng-autocomplete>
                            <ng-template #itemProvince let-item>
                                <a [innerHTML]="item.markup"></a>
                            </ng-template>
            
                            <ng-template #notFoundTemplate let-notFound>
                                <div [innerHTML]="notFound"></div>
                            </ng-template>
            
                            <small class="uk-text-danger uk-position-absolute uk-animation-fast" tabindex="-1">
                                <span>
                                    @if (province_validate()) {
                                        <span>กรุณากรอกจังหวัด</span>
                                    }
                                </span>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            }
            <!-- sub_district -->
            @if (province_name() == 'กรุงเทพมหานคร') {
            <div class="uk-margin-small-bottom">
                <div class="uk-child-width-1-2@s uk-grid">
                    <div>
                        <label class="uk-form-label" for="form_subdistrict">เขต</label>
                        <div class="uk-form-controls uk-position-relative">
                            <input class="uk-input uk-border-rounded" type="hidden" id="district" placeholder="เขตที่คุณอยู่"
                                value="" name="district" [(ngModel)]="model.district" />
                            <ng-autocomplete [data]="results.district" [searchKeyword]="keyword"
                                (selected)="onSelect2($event,'district','current')"
                                (inputChanged)="onChangeSearch2($event,'district','current')"
                                (inputCleared)="onClearSelect('district')" [itemTemplate]="itemDistrict" name="districtText"
                                [(ngModel)]="district" [isLoading]="isLoading" placeholder="เขต"
                                [notFoundTemplate]="notFoundTemplate"></ng-autocomplete>
                            <ng-template #itemDistrict let-item>
                                <a [innerHTML]="item.markup"></a>
                            </ng-template>
            
                            <ng-template #notFoundTemplate let-notFound>
                                <div [innerHTML]="notFound"></div>
                            </ng-template>
                            <small class="uk-text-danger uk-position-absolute uk-animation-fast" tabindex="-1">
                                <span>
                                    @if (district_validate()) {
                                        <span>กรุณากรอกเขต</span>
                                    }
                                </span>
                            </small>
                            <!-- <small class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error"
                                            tabindex="-1" [ngClass]="addClass(f,'province','msg')">
                                            <span>
                                                <span *ngIf="province.errors && province.errors.required">กรุณากรอกจังหวัด</span>
                                            </span>
                                        </small> -->
                        </div>
                    </div>
                </div>
            </div>
            }
            <!-- Email -->
            <div class="uk-margin-small-bottom">
                <div class="uk-child-width-1-2@s uk-grid">
                    <div>
                        <label class="uk-form-label" for="mail-leads">อีเมล</label>
                        <div class="uk-form-controls uk-position-relative">
                            <input class="uk-input uk-border-rounded" type="email" placeholder="mail@company.com"
                                autocomplete="off" inputmode="email" name="email_address"
                                [(ngModel)]="model.email_address" #email_address="ngModel"
                                [ngClass]="addClass(f,'email_address')" email />
                            <small class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error"
                                tabindex="-1" [ngClass]="addClass(f,'email_address','msg')">
                                <span>
                                    @if (email_address.errors && email_address.errors.required) {
                                        <span>กรุณาใส่อีเมล</span>
                                    }
                                    @if (email_address.errors && email_address.errors.email) {
                                        <span>กรุณาตรวจสอบอีเมลให้ถูกต้อง</span>
                                    }
                                </span>
                            </small>
                        </div>
                    </div>
                </div>
            </div>


            <!-- referralCode -->
            <!-- <div class="uk-margin-small-bottom">
                    <div class="uk-child-width-1-2@s uk-grid">
                        <div>
                            <label class="uk-form-label" for="referralCode">รหัสอ้างอิงผู้เเนะนำ</label>
                            <div class="uk-form-controls uk-position-relative">
                                <input
                                    class="uk-input uk-border-rounded" 
                                    type="text"
                                    placeholder="รหัสอ้างอิงผู้เเนะนำ" 
                                    autocomplete="off"
                                    name="referralCode"
                                    [(ngModel)]="model.referralCode" 
                                    #referralCode="ngModel"
                                    [ngClass]="addClass(f,'referralCode')"
                                    />
                                <small class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error" tabindex="-1"
                                [ngClass]="addClass(f,'referralCode','msg')">
                                    <span>
                                        <span *ngIf="referralCode.errors && referralCode.errors.required">กรุณาใส่รหัสอ้างอิงผู้เเนะนำ</span>
                                    </span>
                                </small>
                            </div>
                        </div>
                    </div>
            </div> -->

            <!-- Promotioncode -->
            <div class="uk-margin-small-bottom uk-background-muted uk-padding-small uk-border-rounded">
                <div>
                    <label class="uk-width-auto@m uk-form-label" for="promotion-code">รหัสส่วนลด (ถ้ามี)</label>
                    <div class="uk-width-1-2 uk-width-1-3@s uk-form-controls uk-position-relative">

                        <input class="uk-input uk-border-rounded" id="promotion-code" type="text" placeholder="xxxxxx"
                            autocomplete="off" name="promotion_code" [(ngModel)]="model.promotion_code"
                            #promotion_code="ngModel" [ngClass]="addClass(f,'promotion_code')"
                            remoteValidator="remoteValidator" [validateFunction]="getDiscountInfo" />
                        <small class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error"
                            tabindex="-1" [ngClass]="addClass(f,'promotion_code','msg')">
                            @if (promotion_code.errors && promotion_code.errors.required) {
                                <span>กรุณากรอกส่วนลด</span>
                            }
                            @if (promotion_code.errors && promotion_code.errors.remoteValidator) {
                                <span>รหัสส่วนลดไม่ถูกต้อง</span>
                            }
                        </small>
                    </div>
                </div>

                <div>
                    <label class="uk-width-auto@m uk-form-label" for="referralCode">รหัสอ้างอิงผู้เเนะนำ (ถ้ามี)</label>
                    <div class="uk-width-1-2 uk-width-1-3@s uk-form-controls uk-position-relative">
                        <input class="uk-input uk-border-rounded" type="text" placeholder="xxxxxx" autocomplete="off"
                            name="referralCode" [(ngModel)]="model.referralCode" #referralCode="ngModel"
                            [ngClass]="addClass(f,'referralCode')" />
                    </div>
                </div>

            </div>

            <div class="uk-margin uk-padding-remove-horizontal">
                <div class="uk-flex uk-flex-top">
                    <input 
                    class="consent-checkbox uk-margin-small-right"
                    type="checkbox"
                    name="pdpa_consent"
                    [(ngModel)]="model.pdpa_consent"
                    #pdpa_consent="ngModel"
                    />
                    <span class="uk-text-small">
                        ข้าพเจ้าตกลงยินยอมให้ บริษัท ทิสโก้ อินชัวรันส์ โซลูชั่น จำกัด (“บริษัท”) เก็บรวบรวมและใช้ข้อมูลส่วนบุคคลของข้าพเจ้า 
                        เพื่อทำการติดต่อ และนำเสนอข้อมูลผลิตภัณฑ์ บริการ และสิทธิประโยชน์ของบริษัท <br>
                        ท่านสามารถอ่านประกาศความเป็นส่วนตัว
                        <a href="https://www.tisco.co.th/th/privacy-notice" target="_blank">คลิก</a>
                    </span>
                </div>
            </div>


            <!-- <recaptcha 
            name="myRecaptcha"
            [(ngModel)]="myRecaptcha" 
            class="uk-flex" 
            [ngClass]="addClass(f,'myRecaptcha')"
            ></recaptcha> -->

            <!-- <re-captcha (resolved)="resolved($event)" [siteKey]="YOUR_SITE_KEY"></re-captcha> -->


            <div class="uk-margin uk-padding uk-padding-remove-horizontal uk-text-center">
                <button type="submit" [disabled]="onSubmitInfo || !model.pdpa_consent"
                    class="uk-button uk-button-primary uk-border-rounded">ส่งข้อมูล</button>
            </div>
        </div>
    </div>
</form>

<app-tisco-modal></app-tisco-modal>